"use client";

import { AnimatePresence, m, type Transition } from "motion/react";
import { useState } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";

const LABEL_TRANSITION: Transition = { duration: 0.2, ease: "easeOut" };

export default function TypographyUnderlinesDemo() {
  const [skipInk, setSkipInk] = useState(true);
  const label = skipInk ? "auto" : "none";

  return (
    <DemoWrapper margin="">
      <div className="flex min-h-40 w-full flex-1 items-center justify-center px-6 py-10">
        <span
          className="select-none text-balance text-center text-3xl text-gray-1200 underline decoration-2 decoration-gray-1000 sm:text-4xl"
          style={{
            textDecorationSkipInk: skipInk ? "auto" : "none",
            textUnderlinePosition: "from-font",
          }}
        >
          Typography enjoys gravity
        </span>
      </div>
      <DemoFooter>
        <Button
          className="w-16"
          onClick={() => setSkipInk((value) => !value)}
          rounded
          size="sm"
          type="button"
          variant="secondary"
        >
          <AnimatePresence initial={false} mode="popLayout">
            <m.span
              animate={{ filter: "blur(0px)", opacity: 1 }}
              className="whitespace-nowrap will-change-transform"
              exit={{ filter: "blur(4px)", opacity: 0 }}
              initial={{ filter: "blur(4px)", opacity: 0 }}
              key={label}
              transition={LABEL_TRANSITION}
            >
              {label}
            </m.span>
          </AnimatePresence>
        </Button>
      </DemoFooter>
    </DemoWrapper>
  );
}
